import { render, staticRenderFns } from "./DetailProgram.vue?vue&type=template&id=61b6af22&scoped=true"
import script from "./DetailProgram.vue?vue&type=script&lang=js"
export * from "./DetailProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6af22",
  null
  
)

export default component.exports